import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetDeclaracionJuradaGarantiasLaboralesByID from "services/record/DeclaracionJuradaGarantiasLaborales/useGetDeclaracionJuradaGarantiasLaboralesByID";
import useGetInfoDeclaracionJuradaGarantiasLaborales from "services/record/DeclaracionJuradaGarantiasLaborales/useGetInfoDeclaracionJuradaGarantiasLaborales";
import useGetDeclaracionJuradaGarantiasLaboralesByUser from "services/record/DeclaracionJuradaGarantiasLaborales/useGetDeclaracionJuradaGarantiasLaboralesByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import DeclaracionJuradaGarantiasLaborales from "./DeclaracionJuradaGarantiasLaborales";

const GridDeclaracionJuradaGarantiasLaborales = ({ expedienteId = null, origen = null }) => {

    const {
        getDeclaracionJuradaGarantiasLaboralesByID,
        loadingGetDeclaracionJuradaGarantiasLaboralesByID,
        statusGetDeclaracionJuradaGarantiasLaboralesByID
    } = useGetDeclaracionJuradaGarantiasLaboralesByID();

    const {
        getInfoDeclaracionJuradaGarantiasLaborales,
        loadingGetInfoDeclaracionJuradaGarantiasLaborales,
        statusGetInfoDeclaracionJuradaGarantiasLaborales
    } = useGetInfoDeclaracionJuradaGarantiasLaborales();

    const {
        dataGetDeclaracionJuradaGarantiasLaboralesByUser,
        getDeclaracionJuradaGarantiasLaboralesByUser,
        loadingGetDeclaracionJuradaGarantiasLaboralesByUser,
        statusGetDeclaracionJuradaGarantiasLaboralesByUser
    } = useGetDeclaracionJuradaGarantiasLaboralesByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Declaración jurada de cumplimiento de las garantías laborales";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getDeclaracionJuradaGarantiasLaboralesByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetDeclaracionJuradaGarantiasLaboralesByID?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaGarantiasLaboralesByID.status,
                statusText: statusGetDeclaracionJuradaGarantiasLaboralesByID.statusText
            });
        } else if (statusGetInfoDeclaracionJuradaGarantiasLaborales?.status) {
            setCurrentHttp({
                status: statusGetInfoDeclaracionJuradaGarantiasLaborales.status,
                statusText: statusGetInfoDeclaracionJuradaGarantiasLaborales.statusText
            });
        } else if (statusGetDeclaracionJuradaGarantiasLaboralesByUser?.status) {
            setCurrentHttp({
                status: statusGetDeclaracionJuradaGarantiasLaboralesByUser.status,
                statusText: statusGetDeclaracionJuradaGarantiasLaboralesByUser.statusText
            });
        }
    }, [
        statusGetDeclaracionJuradaGarantiasLaboralesByID,
        statusGetInfoDeclaracionJuradaGarantiasLaborales,
        statusGetDeclaracionJuradaGarantiasLaboralesByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getDeclaracionJuradaGarantiasLaboralesByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoDeclaracionJuradaGarantiasLaborales(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetDeclaracionJuradaGarantiasLaboralesByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 0);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetDeclaracionJuradaGarantiasLaboralesByUser]);

    const isLoading = () => {
        return (
            loadingGetDeclaracionJuradaGarantiasLaboralesByID ||
            loadingGetInfoDeclaracionJuradaGarantiasLaborales ||
            (loadingGetDeclaracionJuradaGarantiasLaboralesByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetDeclaracionJuradaGarantiasLaboralesByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <DeclaracionJuradaGarantiasLaborales
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getDeclaracionJuradaGarantiasLaboralesByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && !isLoading() && ![200, 204].includes(currentHttp.status) && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridDeclaracionJuradaGarantiasLaborales;

